import {
  CURRENT_REPORT,
  GET_LAST_SC_SETS_REQUEST,
  GET_LAST_SC_SETS_SUCCESS,
  GET_LAST_SC_SETS_FAILURE,
  CURRENT_SAVED_REPORT,
  SAVE_USER_FAILURE,
  SAVE_USER_REQUEST,
  SAVE_USER_SUCCESS,
  SAVE_RECENT_USER_REPORT_REQUEST,
  SAVE_RECENT_USER_REPORT_SUCCESS,
  SAVE_RECENT_USER_REPORT_FAILURE,
  SAVE_USER_REPORT_REQUEST,
  SAVE_USER_REPORT_SUCCESS,
  SAVE_USER_REPORT_FAILURE,
  DELETE_SAVED_USER_REPORT_REQUEST,
  DELETE_SAVED_USER_REPORT_SUCCESS,
  DELETE_SAVED_USER_REPORT_FAILURE,
  PIN_USER_REPORT_REQUEST,
  PIN_USER_REPORT_SUCCESS,
  PIN_USER_REPORT_FAILURE,
  SAVE_USER_IMPC_SELECTION_FAILURE,
  SAVE_USER_IMPC_SELECTION_REQUEST,
  SAVE_USER_IMPC_SELECTION_SUCCESS,
  SAVE_USER_OPERATOR_SELECTION_REQUEST,
  SAVE_USER_OPERATOR_SELECTION_SUCCESS,
  SAVE_USER_OPERATOR_SELECTION_FAILURE,
  SAVE_USER_MRD_IMPC_SELECTION_FAILURE,
  SAVE_USER_MRD_IMPC_SELECTION_REQUEST,
  SAVE_USER_MRD_IMPC_SELECTION_SUCCESS,
  SAVE_USER_CARRIER_SELECTION_FAILURE,
  SAVE_USER_CARRIER_SELECTION_REQUEST,
  SAVE_USER_CARRIER_SELECTION_SUCCESS,
  SAVE_USER_HANDLER_SELECTION_FAILURE,
  SAVE_USER_HANDLER_SELECTION_REQUEST,
  SAVE_USER_HANDLER_SELECTION_SUCCESS,
  SAVE_USER_MAILBOX_SELECTION_FAILURE,
  SAVE_USER_MAILBOX_SELECTION_REQUEST,
  SAVE_USER_MAILBOX_SELECTION_SUCCESS,
  SAVE_USER_UNLOCODE_SELECTION_FAILURE,
  SAVE_USER_UNLOCODE_SELECTION_REQUEST,
  SAVE_USER_UNLOCODE_SELECTION_SUCCESS,
  SAVE_USER_LAST_SELECTION_FAILURE,
  SAVE_USER_LAST_SELECTION_REQUEST,
  SAVE_USER_LAST_SELECTION_SUCCESS,
  SAVE_USER_LAST_OPERATOR_EDI_MAILBOX_SELECTION_REQUEST,
  SAVE_USER_LAST_OPERATOR_EDI_MAILBOX_SELECTION_SUCCESS,
  SAVE_USER_LAST_OPERATOR_EDI_MAILBOX_SELECTION_FAILURE,
  SAVE_USER_LAST_COUNTRY_UNLOCODE_SELECTION_REQUEST,
  SAVE_USER_LAST_COUNTRY_UNLOCODE_SELECTION_SUCCESS,
  SAVE_USER_LAST_COUNTRY_UNLOCODE_SELECTION_FAILURE,
  SAVE_USER_LAST_OPERATOR_IMPC_SELECTION_REQUEST,
  SAVE_USER_LAST_OPERATOR_IMPC_SELECTION_SUCCESS,
  SAVE_USER_LAST_OPERATOR_IMPC_SELECTION_FAILURE,
  SAVE_USER_LAST_OPERATOR_IMPC_PRODUCT_SELECTION_REQUEST,
  SAVE_USER_LAST_OPERATOR_IMPC_PRODUCT_SELECTION_SUCCESS,
  SAVE_USER_LAST_OPERATOR_IMPC_PRODUCT_SELECTION_FAILURE,
  SAVE_USER_LAST_OPERATORNA_IMPC_SELECTION_REQUEST,
  SAVE_USER_LAST_OPERATORNA_IMPC_SELECTION_SUCCESS,
  SAVE_USER_LAST_OPERATORNA_IMPC_SELECTION_FAILURE,
  SAVE_USER_LAST_OPERATORNA_IMPC_PRODUCT_SELECTION_REQUEST,
  SAVE_USER_LAST_OPERATORNA_IMPC_PRODUCT_SELECTION_SUCCESS,
  SAVE_USER_LAST_OPERATORNA_IMPC_PRODUCT_SELECTION_FAILURE,
  SAVE_USER_LAST_MRD_OPERATOR_IMPC_SELECTION_REQUEST,
  SAVE_USER_LAST_MRD_OPERATOR_IMPC_SELECTION_SUCCESS,
  SAVE_USER_LAST_MRD_OPERATOR_IMPC_SELECTION_FAILURE,
  SAVE_USER_LAST_HANDLER_SELECTION_REQUEST,
  SAVE_USER_LAST_HANDLER_SELECTION_SUCCESS,
  SAVE_USER_LAST_HANDLER_SELECTION_FAILURE,
  SAVE_USER_LAST_CARRIER_SELECTION_REQUEST,
  SAVE_USER_LAST_CARRIER_SELECTION_SUCCESS,
  SAVE_USER_LAST_CARRIER_SELECTION_FAILURE,
  SAVE_USER_LAST_OPERATORNA_CARRIER_PRODUCT_SELECTION_REQUEST,
  SAVE_USER_LAST_OPERATORNA_CARRIER_PRODUCT_SELECTION_SUCCESS,
  SAVE_USER_LAST_OPERATORNA_CARRIER_PRODUCT_SELECTION_FAILURE,
  SAVE_USER_PRODUCT_SELECTION_FAILURE,
  SAVE_USER_PRODUCT_SELECTION_REQUEST,
  SAVE_USER_PRODUCT_SELECTION_SUCCESS,
  FETCH_USER_IMPC_SELECTIONS_FAILURE,
  FETCH_USER_IMPC_SELECTIONS_REQUEST,
  FETCH_USER_IMPC_SELECTIONS_SUCCESS,
  FETCH_USER_OPERATOR_SELECTIONS_FAILURE,
  FETCH_USER_OPERATOR_SELECTIONS_REQUEST,
  FETCH_USER_OPERATOR_SELECTIONS_SUCCESS,
  FETCH_USER_MRD_IMPC_SELECTIONS_FAILURE,
  FETCH_USER_MRD_IMPC_SELECTIONS_REQUEST,
  FETCH_USER_MRD_IMPC_SELECTIONS_SUCCESS,
  FETCH_USER_CARRIER_SELECTIONS_FAILURE,
  FETCH_USER_CARRIER_SELECTIONS_REQUEST,
  FETCH_USER_CARRIER_SELECTIONS_SUCCESS,
  FETCH_USER_HANDLER_SELECTIONS_FAILURE,
  FETCH_USER_HANDLER_SELECTIONS_REQUEST,
  FETCH_USER_HANDLER_SELECTIONS_SUCCESS,
  FETCH_USER_MAILBOX_SELECTIONS_FAILURE,
  FETCH_USER_MAILBOX_SELECTIONS_REQUEST,
  FETCH_USER_MAILBOX_SELECTIONS_SUCCESS,
  FETCH_USER_UNLOCODE_SELECTIONS_FAILURE,
  FETCH_USER_UNLOCODE_SELECTIONS_REQUEST,
  FETCH_USER_UNLOCODE_SELECTIONS_SUCCESS,
  FETCH_USER_PRODUCT_SELECTIONS_FAILURE,
  FETCH_USER_PRODUCT_SELECTIONS_REQUEST,
  FETCH_USER_PRODUCT_SELECTIONS_SUCCESS,
  FETCH_USER_DATA_REQUEST,
  FETCH_USER_DATA_SUCCESS,
  FETCH_USER_DATA_FAILURE,
  DELETE_USER_IMPC_SELECTION_REQUEST,
  DELETE_USER_IMPC_SELECTION_FAILURE,
  DELETE_USER_IMPC_SELECTION_SUCCESS,
  DELETE_USER_OPERATOR_SELECTION_REQUEST,
  DELETE_USER_OPERATOR_SELECTION_SUCCESS,
  DELETE_USER_OPERATOR_SELECTION_FAILURE,
  DELETE_USER_MRD_IMPC_SELECTION_REQUEST,
  DELETE_USER_MRD_IMPC_SELECTION_FAILURE,
  DELETE_USER_MRD_IMPC_SELECTION_SUCCESS,
  DELETE_USER_CARRIER_SELECTION_REQUEST,
  DELETE_USER_CARRIER_SELECTION_FAILURE,
  DELETE_USER_CARRIER_SELECTION_SUCCESS,
  DELETE_USER_HANDLER_SELECTION_REQUEST,
  DELETE_USER_HANDLER_SELECTION_FAILURE,
  DELETE_USER_HANDLER_SELECTION_SUCCESS,
  DELETE_USER_MAILBOX_SELECTION_REQUEST,
  DELETE_USER_MAILBOX_SELECTION_FAILURE,
  DELETE_USER_MAILBOX_SELECTION_SUCCESS,
  DELETE_USER_UNLOCODE_SELECTION_REQUEST,
  DELETE_USER_UNLOCODE_SELECTION_FAILURE,
  DELETE_USER_UNLOCODE_SELECTION_SUCCESS,
  DELETE_USER_PRODUCT_SELECTION_REQUEST,
  DELETE_USER_PRODUCT_SELECTION_FAILURE,
  DELETE_USER_PRODUCT_SELECTION_SUCCESS,
  SAVE_DEFAULT_LAUNCH_PAGE_REQUEST,
  SAVE_DEFAULT_LAUNCH_PAGE_SUCCESS,
  SAVE_DEFAULT_LAUNCH_PAGE_FAILURE,
  CREATE_REQ_PARAM,
  SAVE_USER_LAST_OPERATOR_PRODUCT_SELECTION_REQUEST,
  SAVE_USER_LAST_OPERATOR_PRODUCT_SELECTION_SUCCESS,
  SAVE_USER_LAST_OPERATOR_PRODUCT_SELECTION_FAILURE,
  SAVE_USER_LAST_OPERATORNA_SELECTION_REQUEST,
  SAVE_USER_LAST_OPERATORNA_SELECTION_SUCCESS,
  SAVE_USER_LAST_OPERATORNA_SELECTION_FAILURE,
  SAVE_USER_LAST_OPERATORNA_PRODUCT_SELECTION_REQUEST,
  SAVE_USER_LAST_OPERATORNA_PRODUCT_SELECTION_SUCCESS,
  SAVE_USER_LAST_OPERATORNA_PRODUCT_SELECTION_FAILURE,
  SAVE_USER_LAST_OPERATOR_SELECTION_REQUEST,
  SAVE_USER_LAST_OPERATOR_SELECTION_SUCCESS,
  SAVE_USER_LAST_OPERATOR_SELECTION_FAILURE,
  FAILED_REPORTS_DEFINITIONS_REQUEST,
  SENT_LAST_SELECTIONS,
  USERLOADED,
  LASTSELECTIONSLOADED,
} from './types/UserActionTypes';

export function currentUserReportActionCreator(reportCode) {
  return {
    type: CURRENT_REPORT,
    reportCode,
  };
}

export function currentSavedUserReportActionCreator(savedId) {
  return {
    type: CURRENT_SAVED_REPORT,
    savedId,
  };
}

export function saveUserRequestActionCreator() {
  return {
    type: SAVE_USER_REQUEST,
  };
}

export function saveUserSuccessActionCreator() {
  return {
    type: SAVE_USER_SUCCESS,
  };
}

export function saveUserFailureActionCreator(error) {
  return {
    type: SAVE_USER_FAILURE,
    payload: error,
    error: true,
  };
}

export function saveRecentUserReportRequestActionCreator(params) {
  return {
    type: SAVE_RECENT_USER_REPORT_REQUEST,
    payload: {
      ...params,
    },
  };
}

export function saveRecentUserReportSuccessActionCreator(payload) {
  return {
    type: SAVE_RECENT_USER_REPORT_SUCCESS,
    payload,
  };
}

export function saveRecentUserReportFailureActionCreator(error) {
  return {
    type: SAVE_RECENT_USER_REPORT_FAILURE,
    payload: error,
    error: true,
  };
}

export function saveUserReportRequestActionCreator(params) {
  return {
    type: SAVE_USER_REPORT_REQUEST,
    payload: {
      ...params,
    },
  };
}

export function saveUserReportSuccessActionCreator(payload) {
  return {
    type: SAVE_USER_REPORT_SUCCESS,
    payload,
  };
}

export function saveUserReportFailureActionCreator(error) {
  return {
    type: SAVE_USER_REPORT_FAILURE,
    payload: error,
    error: true,
  };
}

export function deleteSavedUserReportRequestActionCreator(savedId) {
  return {
    type: DELETE_SAVED_USER_REPORT_REQUEST,
    payload: {
      savedId,
    },
  };
}

export function deleteSavedUserReportSuccessActionCreator(payload) {
  return {
    type: DELETE_SAVED_USER_REPORT_SUCCESS,
    payload,
  };
}

export function deleteSavedUserReportFailureActionCreator(error) {
  return {
    type: DELETE_SAVED_USER_REPORT_FAILURE,
    payload: error,
    error: true,
  };
}

export function pinUserReportRequestActionCreator(payload) {
  return {
    type: PIN_USER_REPORT_REQUEST,
    payload,
  };
}

export function pinUserReportSuccessActionCreator(payload) {
  return {
    type: PIN_USER_REPORT_SUCCESS,
    payload,
  };
}

export function pinUserReportFailureActionCreator(error) {
  return {
    type: PIN_USER_REPORT_FAILURE,
    payload: error,
    error: true,
  };
}

export function saveLastUserSelectionRequestActionCreator(selection) {
  return {
    type: SAVE_USER_LAST_SELECTION_REQUEST,
    payload: selection,
  };
}

export function saveLastUserSelectionSuccessActionCreator() {
  return {
    type: SAVE_USER_LAST_SELECTION_SUCCESS,
  };
}

export function saveLastUserSelectionFailureActionCreator(error) {
  return {
    type: SAVE_USER_LAST_SELECTION_FAILURE,
    payload: error,
    error: true,
  };
}

export function saveLastUserOperatorEdiMailboxSelectionRequestActionCreator(selection) {
  return {
    type: SAVE_USER_LAST_OPERATOR_EDI_MAILBOX_SELECTION_REQUEST,
    payload: selection,
  };
}

export function saveLastUserOperatorEdiMailboxSelectionSuccessActionCreator() {
  return {
    type: SAVE_USER_LAST_OPERATOR_EDI_MAILBOX_SELECTION_SUCCESS,
  };
}

export function saveLastUserOperatorEdiMailboxSelectionFailureActionCreator(error) {
  return {
    type: SAVE_USER_LAST_OPERATOR_EDI_MAILBOX_SELECTION_FAILURE,
    payload: error,
    error: true,
  };
}

export function saveLastUserCountryUnlocodeSelectionRequestActionCreator(selection) {
  return {
    type: SAVE_USER_LAST_COUNTRY_UNLOCODE_SELECTION_REQUEST,
    payload: selection,
  };
}

export function saveLastUserCountryUnlocodeSelectionSuccessActionCreator() {
  return {
    type: SAVE_USER_LAST_COUNTRY_UNLOCODE_SELECTION_SUCCESS,
  };
}

export function saveLastUserCountryUnlocodeSelectionFailureActionCreator(error) {
  return {
    type: SAVE_USER_LAST_COUNTRY_UNLOCODE_SELECTION_FAILURE,
    payload: error,
    error: true,
  };
}

export function saveLastUserOperatorImpcProductSelectionRequestActionCreator(selection) {
  return {
    type: SAVE_USER_LAST_OPERATOR_IMPC_PRODUCT_SELECTION_REQUEST,
    payload: selection,
  };
}

export function saveLastUserOperatorImpcProductSelectionSuccessActionCreator() {
  return {
    type: SAVE_USER_LAST_OPERATOR_IMPC_PRODUCT_SELECTION_SUCCESS,
  };
}

export function saveLastUserOperatorImpcProductSelectionFailureActionCreator(error) {
  return {
    type: SAVE_USER_LAST_OPERATOR_IMPC_PRODUCT_SELECTION_FAILURE,
    payload: error,
    error: true,
  };
}

export function saveLastUserOperatorProductSelectionRequestActionCreator(selection) {
  return {
    type: SAVE_USER_LAST_OPERATOR_PRODUCT_SELECTION_REQUEST,
    payload: selection,
  };
}

export function saveLastUserOperatorProductSelectionSuccessActionCreator() {
  return {
    type: SAVE_USER_LAST_OPERATOR_PRODUCT_SELECTION_SUCCESS,
  };
}

export function saveLastUserOperatorProductSelectionFailureActionCreator(error) {
  return {
    type: SAVE_USER_LAST_OPERATOR_PRODUCT_SELECTION_FAILURE,
    payload: error,
    error: true,
  };
}

export function saveLastUserOperatorNaImpcProductSelectionRequestActionCreator(selection) {
  return {
    type: SAVE_USER_LAST_OPERATORNA_IMPC_PRODUCT_SELECTION_REQUEST,
    payload: selection,
  };
}

export function saveLastUserOperatorNaImpcProductSelectionSuccessActionCreator() {
  return {
    type: SAVE_USER_LAST_OPERATORNA_IMPC_PRODUCT_SELECTION_SUCCESS,
  };
}

export function saveLastUserOperatorNaImpcProductSelectionFailureActionCreator(error) {
  return {
    type: SAVE_USER_LAST_OPERATORNA_IMPC_PRODUCT_SELECTION_FAILURE,
    payload: error,
    error: true,
  };
}

export function saveLastUserOperatorNaProductSelectionRequestActionCreator(selection) {
  return {
    type: SAVE_USER_LAST_OPERATORNA_PRODUCT_SELECTION_REQUEST,
    payload: selection,
  };
}

export function saveLastUserOperatorNaProductSelectionSuccessActionCreator() {
  return {
    type: SAVE_USER_LAST_OPERATORNA_PRODUCT_SELECTION_SUCCESS,
  };
}

export function saveLastUserOperatorNaProductSelectionFailureActionCreator(error) {
  return {
    type: SAVE_USER_LAST_OPERATORNA_PRODUCT_SELECTION_FAILURE,
    payload: error,
    error: true,
  };
}

export function saveLastUserOperatorNaImpcSelectionRequestActionCreator(selection) {
  return {
    type: SAVE_USER_LAST_OPERATORNA_IMPC_SELECTION_REQUEST,
    payload: selection,
  };
}

export function saveLastUserOperatorNaImpcSelectionSuccessActionCreator() {
  return {
    type: SAVE_USER_LAST_OPERATORNA_IMPC_SELECTION_SUCCESS,
  };
}

export function saveLastUserOperatorNaImpcSelectionFailureActionCreator(error) {
  return {
    type: SAVE_USER_LAST_OPERATORNA_IMPC_SELECTION_FAILURE,
    payload: error,
    error: true,
  };
}

export function saveLastUserOperatorNaSelectionRequestActionCreator(selection) {
  return {
    type: SAVE_USER_LAST_OPERATORNA_SELECTION_REQUEST,
    payload: selection,
  };
}

export function saveLastUserOperatorNaSelectionSuccessActionCreator() {
  return {
    type: SAVE_USER_LAST_OPERATORNA_SELECTION_SUCCESS,
  };
}

export function saveLastUserOperatorNaSelectionFailureActionCreator(error) {
  return {
    type: SAVE_USER_LAST_OPERATORNA_SELECTION_FAILURE,
    payload: error,
    error: true,
  };
}

export function saveLastUserOperatorImpcSelectionRequestActionCreator(selection) {
  return {
    type: SAVE_USER_LAST_OPERATOR_IMPC_SELECTION_REQUEST,
    payload: selection,
  };
}

export function saveLastUserOperatorImpcSelectionSuccessActionCreator() {
  return {
    type: SAVE_USER_LAST_OPERATOR_IMPC_SELECTION_SUCCESS,
  };
}

export function saveLastUserOperatorImpcSelectionFailureActionCreator(error) {
  return {
    type: SAVE_USER_LAST_OPERATOR_IMPC_SELECTION_FAILURE,
    payload: error,
    error: true,
  };
}

export function saveLastUserOperatorSelectionRequestActionCreator(selection) {
  return {
    type: SAVE_USER_LAST_OPERATOR_SELECTION_REQUEST,
    payload: selection,
  };
}

export function saveLastUserOperatorSelectionSuccessActionCreator() {
  return {
    type: SAVE_USER_LAST_OPERATOR_SELECTION_SUCCESS,
  };
}

export function saveLastUserOperatorSelectionFailureActionCreator(error) {
  return {
    type: SAVE_USER_LAST_OPERATOR_SELECTION_FAILURE,
    payload: error,
    error: true,
  };
}

export function saveLastUserMrdOperatorImpcSelectionRequestActionCreator(selection) {
  return {
    type: SAVE_USER_LAST_MRD_OPERATOR_IMPC_SELECTION_REQUEST,
    payload: selection,
  };
}

export function saveLastUserMrdOperatorImpcSelectionSuccessActionCreator() {
  return {
    type: SAVE_USER_LAST_MRD_OPERATOR_IMPC_SELECTION_SUCCESS,
  };
}

export function saveLastUserMrdOperatorImpcSelectionFailureActionCreator(error) {
  return {
    type: SAVE_USER_LAST_MRD_OPERATOR_IMPC_SELECTION_FAILURE,
    payload: error,
    error: true,
  };
}

export function saveLastUserHandlerSelectionRequestActionCreator(selection) {
  return {
    type: SAVE_USER_LAST_HANDLER_SELECTION_REQUEST,
    payload: selection,
  };
}

export function saveLastUserHandlerSelectionSuccessActionCreator() {
  return {
    type: SAVE_USER_LAST_HANDLER_SELECTION_SUCCESS,
  };
}

export function saveLastUserHandlerSelectionFailureActionCreator(error) {
  return {
    type: SAVE_USER_LAST_HANDLER_SELECTION_FAILURE,
    payload: error,
    error: true,
  };
}

export function saveLastUserCarrierSelectionRequestActionCreator(selection) {
  return {
    type: SAVE_USER_LAST_CARRIER_SELECTION_REQUEST,
    payload: selection,
  };
}

export function saveLastUserCarrierSelectionSuccessActionCreator() {
  return {
    type: SAVE_USER_LAST_CARRIER_SELECTION_SUCCESS,
  };
}

export function saveLastUserCarrierSelectionFailureActionCreator(error) {
  return {
    type: SAVE_USER_LAST_CARRIER_SELECTION_FAILURE,
    payload: error,
    error: true,
  };
}

export function saveLastUserOperatorNaCarrierProductSelectionRequestActionCreator(selection) {
  return {
    type: SAVE_USER_LAST_OPERATORNA_CARRIER_PRODUCT_SELECTION_REQUEST,
    payload: selection,
  };
}

export function saveLastUserOperatorNaCarrierProductSelectionSuccessActionCreator() {
  return {
    type: SAVE_USER_LAST_OPERATORNA_CARRIER_PRODUCT_SELECTION_SUCCESS,
  };
}

export function saveLastUserOperatorNaCarrierProductSelectionFailureActionCreator(error) {
  return {
    type: SAVE_USER_LAST_OPERATORNA_CARRIER_PRODUCT_SELECTION_FAILURE,
    payload: error,
    error: true,
  };
}

export function saveUserIMPCSelectionRequestActionCreator(selectionName, selectedIMPCCodes) {
  return {
    type: SAVE_USER_IMPC_SELECTION_REQUEST,
    payload: {
      selectionName,
      selectedIMPCCodes,
    },
  };
}

export function saveUserIMPCSelectionSuccessActionCreator() {
  return {
    type: SAVE_USER_IMPC_SELECTION_SUCCESS,
  };
}

export function saveUserIMPCSelectionFailureActionCreator(error) {
  return {
    type: SAVE_USER_IMPC_SELECTION_FAILURE,
    payload: error,
    error: true,
  };
}

export function saveUserOperatorSelectionRequestActionCreator(selectionName, selectedIMPCCodes) {
  return {
    type: SAVE_USER_OPERATOR_SELECTION_REQUEST,
    payload: {
      selectionName,
      selectedIMPCCodes,
    },
  };
}

export function saveUserOperatorSelectionSuccessActionCreator() {
  return {
    type: SAVE_USER_OPERATOR_SELECTION_SUCCESS,
  };
}

export function saveUserOperatorSelectionFailureActionCreator(error) {
  return {
    type: SAVE_USER_OPERATOR_SELECTION_FAILURE,
    payload: error,
    error: true,
  };
}

export function saveUserMrdImpcSelectionRequestActionCreator(selectionName, selectedIMPCCodes) {
  return {
    type: SAVE_USER_MRD_IMPC_SELECTION_REQUEST,
    payload: {
      selectionName,
      selectedIMPCCodes,
    },
  };
}

export function saveUserMrdImpcSelectionSuccessActionCreator() {
  return {
    type: SAVE_USER_MRD_IMPC_SELECTION_SUCCESS,
  };
}

export function saveUserMrdImpcSelectionFailureActionCreator(error) {
  return {
    type: SAVE_USER_MRD_IMPC_SELECTION_FAILURE,
    payload: error,
    error: true,
  };
}

export function saveUserCarrierSelectionRequestActionCreator(selectionName, selectedCarriers) {
  return {
    type: SAVE_USER_CARRIER_SELECTION_REQUEST,
    payload: {
      selectionName,
      selectedCarriers,
    },
  };
}

export function saveUserCarrierSelectionSuccessActionCreator() {
  return {
    type: SAVE_USER_CARRIER_SELECTION_SUCCESS,
  };
}

export function saveUserCarrierSelectionFailureActionCreator(error) {
  return {
    type: SAVE_USER_CARRIER_SELECTION_FAILURE,
    payload: error,
    error: true,
  };
}

export function saveUserHandlerSelectionRequestActionCreator(selectionName, selectedHandlers) {
  return {
    type: SAVE_USER_HANDLER_SELECTION_REQUEST,
    payload: {
      selectionName,
      selectedHandlers,
    },
  };
}

export function saveUserHandlerSelectionSuccessActionCreator() {
  return {
    type: SAVE_USER_HANDLER_SELECTION_SUCCESS,
  };
}

export function saveUserHandlerSelectionFailureActionCreator(error) {
  return {
    type: SAVE_USER_HANDLER_SELECTION_FAILURE,
    payload: error,
    error: true,
  };
}

export function saveUserMailboxSelectionRequestActionCreator(selectionName, selectedEdiMailboxes) {
  return {
    type: SAVE_USER_MAILBOX_SELECTION_REQUEST,
    payload: {
      selectionName,
      selectedEdiMailboxes,
    },
  };
}

export function saveUserMailboxSelectionSuccessActionCreator() {
  return {
    type: SAVE_USER_MAILBOX_SELECTION_SUCCESS,
  };
}

export function saveUserMailboxSelectionFailureActionCreator(error) {
  return {
    type: SAVE_USER_MAILBOX_SELECTION_FAILURE,
    payload: error,
    error: true,
  };
}

export function saveUserUnlocodeSelectionRequestActionCreator(selectionName, selectedUnlocodes) {
  return {
    type: SAVE_USER_UNLOCODE_SELECTION_REQUEST,
    payload: {
      selectionName,
      selectedUnlocodes,
    },
  };
}

export function saveUserUnlocodeSelectionSuccessActionCreator() {
  return {
    type: SAVE_USER_UNLOCODE_SELECTION_SUCCESS,
  };
}

export function saveUserUnlocodeSelectionFailureActionCreator(error) {
  return {
    type: SAVE_USER_UNLOCODE_SELECTION_FAILURE,
    payload: error,
    error: true,
  };
}

export function saveUserProductSelectionRequestActionCreator(selectionName, selectedProducts) {
  return {
    type: SAVE_USER_PRODUCT_SELECTION_REQUEST,
    payload: {
      selectionName,
      selectedProducts,
    },
  };
}

export function saveUserProductSelectionSuccessActionCreator() {
  return {
    type: SAVE_USER_PRODUCT_SELECTION_SUCCESS,
  };
}

export function saveUserProductSelectionFailureActionCreator(error) {
  return {
    type: SAVE_USER_PRODUCT_SELECTION_FAILURE,
    payload: error,
    error: true,
  };
}

export function fetchUserIMPCSelectionsRequestActionCreator(postalOperatorType) {
  return {
    type: FETCH_USER_IMPC_SELECTIONS_REQUEST,
    payload: postalOperatorType,
  };
}

export function fetchUserIMPCSelectionsSuccessActionCreator(postalOperatorType, selections) {
  return {
    type: FETCH_USER_IMPC_SELECTIONS_SUCCESS,
    payload: {
      postalOperatorType,
      selections,
    },
  };
}

export function fetchUserIMPCSelectionsFailureActionCreator(error) {
  return {
    type: FETCH_USER_IMPC_SELECTIONS_FAILURE,
    payload: error,
    error: true,
  };
}

export function fetchUserOperatorSelectionsRequestActionCreator(postalOperatorType) {
  return {
    type: FETCH_USER_OPERATOR_SELECTIONS_REQUEST,
    payload: postalOperatorType,
  };
}

export function fetchUserOperatorSelectionsSuccessActionCreator(postalOperatorType, selections) {
  return {
    type: FETCH_USER_OPERATOR_SELECTIONS_SUCCESS,
    payload: {
      postalOperatorType,
      selections,
    },
  };
}

export function fetchUserOperatorSelectionsFailureActionCreator(error) {
  return {
    type: FETCH_USER_OPERATOR_SELECTIONS_FAILURE,
    payload: error,
    error: true,
  };
}

export function fetchUserMrdImpcSelectionsRequestActionCreator(postalOperatorType) {
  return {
    type: FETCH_USER_MRD_IMPC_SELECTIONS_REQUEST,
    payload: postalOperatorType,
  };
}

export function fetchUserMrdImpcSelectionsSuccessActionCreator(postalOperatorType, selections) {
  return {
    type: FETCH_USER_MRD_IMPC_SELECTIONS_SUCCESS,
    payload: {
      postalOperatorType,
      selections,
    },
  };
}

export function fetchUserMrdImpcSelectionsFailureActionCreator(error) {
  return {
    type: FETCH_USER_MRD_IMPC_SELECTIONS_FAILURE,
    payload: error,
    error: true,
  };
}

export function fetchUserCarrierSelectionsRequestActionCreator() {
  return {
    type: FETCH_USER_CARRIER_SELECTIONS_REQUEST,
  };
}

export function fetchUserCarrierSelectionsSuccessActionCreator(selections) {
  return {
    type: FETCH_USER_CARRIER_SELECTIONS_SUCCESS,
    payload: {
      selections,
    },
  };
}

export function fetchUserCarrierSelectionsFailureActionCreator(error) {
  return {
    type: FETCH_USER_CARRIER_SELECTIONS_FAILURE,
    payload: error,
    error: true,
  };
}

export function fetchUserHandlerSelectionsRequestActionCreator() {
  return {
    type: FETCH_USER_HANDLER_SELECTIONS_REQUEST,
  };
}

export function fetchUserHandlerSelectionsSuccessActionCreator(selections) {
  return {
    type: FETCH_USER_HANDLER_SELECTIONS_SUCCESS,
    payload: {
      selections,
    },
  };
}

export function fetchUserHandlerSelectionsFailureActionCreator(error) {
  return {
    type: FETCH_USER_HANDLER_SELECTIONS_FAILURE,
    payload: error,
    error: true,
  };
}

export function fetchUserMailboxSelectionsRequestActionCreator(postalOperatorType) {
  return {
    type: FETCH_USER_MAILBOX_SELECTIONS_REQUEST,
    payload: postalOperatorType,
  };
}

export function fetchUserMailboxSelectionsSuccessActionCreator(postalOperatorType, selections) {
  return {
    type: FETCH_USER_MAILBOX_SELECTIONS_SUCCESS,
    payload: {
      postalOperatorType,
      selections,
    },
  };
}

export function fetchUserMailboxSelectionsFailureActionCreator(error) {
  return {
    type: FETCH_USER_MAILBOX_SELECTIONS_FAILURE,
    payload: error,
    error: true,
  };
}

export function fetchUserUnlocodeSelectionsRequestActionCreator(postalOperatorType) {
  return {
    type: FETCH_USER_UNLOCODE_SELECTIONS_REQUEST,
    payload: postalOperatorType,
  };
}

export function fetchUserUnlocodeSelectionsSuccessActionCreator(postalOperatorType, selections) {
  return {
    type: FETCH_USER_UNLOCODE_SELECTIONS_SUCCESS,
    payload: {
      postalOperatorType,
      selections,
    },
  };
}

export function fetchUserUnlocodeSelectionsFailureActionCreator(error) {
  return {
    type: FETCH_USER_UNLOCODE_SELECTIONS_FAILURE,
    payload: error,
    error: true,
  };
}

export function fetchUserProductSelectionsRequestActionCreator() {
  return {
    type: FETCH_USER_PRODUCT_SELECTIONS_REQUEST,
  };
}

export function fetchUserProductSelectionsSuccessActionCreator(selections) {
  return {
    type: FETCH_USER_PRODUCT_SELECTIONS_SUCCESS,
    payload: {
      selections,
    },
  };
}

export function fetchUserProductSelectionsFailureActionCreator(error) {
  return {
    type: FETCH_USER_PRODUCT_SELECTIONS_FAILURE,
    payload: error,
    error: true,
  };
}

export function deleteUserImpcSelectionRequestActionCreator(selectionName) {
  return {
    type: DELETE_USER_IMPC_SELECTION_REQUEST,
    payload: selectionName,
  };
}

export function deleteUserImpcSelectionFailureActionCreator(error) {
  return {
    type: DELETE_USER_IMPC_SELECTION_FAILURE,
    payload: error,
    error: true,
  };
}

export function deleteUserImpcSelectionSuccessActionCreator() {
  return {
    type: DELETE_USER_IMPC_SELECTION_SUCCESS,
  };
}

export function deleteUserOperatorSelectionRequestActionCreator(selectionName) {
  return {
    type: DELETE_USER_OPERATOR_SELECTION_REQUEST,
    payload: selectionName,
  };
}

export function deleteUserOperatorSelectionSuccessActionCreator() {
  return {
    type: DELETE_USER_OPERATOR_SELECTION_SUCCESS,
  };
}

export function deleteUserOperatorSelectionFailureActionCreator(error) {
  return {
    type: DELETE_USER_OPERATOR_SELECTION_FAILURE,
    payload: error,
    error: true,
  };
}

export function deleteUserMrdImpcSelectionRequestActionCreator(selectionName) {
  return {
    type: DELETE_USER_MRD_IMPC_SELECTION_REQUEST,
    payload: selectionName,
  };
}

export function deleteUserMrdImpcSelectionFailureActionCreator(error) {
  return {
    type: DELETE_USER_MRD_IMPC_SELECTION_FAILURE,
    payload: error,
    error: true,
  };
}

export function deleteUserMrdImpcSelectionSuccessActionCreator() {
  return {
    type: DELETE_USER_MRD_IMPC_SELECTION_SUCCESS,
  };
}

export function deleteUserCarrierSelectionRequestActionCreator(selectionName) {
  return {
    type: DELETE_USER_CARRIER_SELECTION_REQUEST,
    payload: selectionName,
  };
}

export function deleteUserCarrierSelectionFailureActionCreator(error) {
  return {
    type: DELETE_USER_CARRIER_SELECTION_FAILURE,
    payload: error,
    error: true,
  };
}

export function deleteUserCarrierSelectionSuccessActionCreator() {
  return {
    type: DELETE_USER_CARRIER_SELECTION_SUCCESS,
  };
}

export function deleteUserHandlerSelectionRequestActionCreator(selectionName) {
  return {
    type: DELETE_USER_HANDLER_SELECTION_REQUEST,
    payload: selectionName,
  };
}

export function deleteUserHandlerSelectionFailureActionCreator(error) {
  return {
    type: DELETE_USER_HANDLER_SELECTION_FAILURE,
    payload: error,
    error: true,
  };
}

export function deleteUserHandlerSelectionSuccessActionCreator() {
  return {
    type: DELETE_USER_HANDLER_SELECTION_SUCCESS,
  };
}

export function deleteUserMailboxSelectionRequestActionCreator(selectionName) {
  return {
    type: DELETE_USER_MAILBOX_SELECTION_REQUEST,
    payload: selectionName,
  };
}

export function deleteUserMailboxSelectionFailureActionCreator(error) {
  return {
    type: DELETE_USER_MAILBOX_SELECTION_FAILURE,
    payload: error,
    error: true,
  };
}

export function deleteUserMailboxSelectionSuccessActionCreator() {
  return {
    type: DELETE_USER_MAILBOX_SELECTION_SUCCESS,
  };
}

export function deleteUserUnlocodeSelectionRequestActionCreator(selectionName) {
  return {
    type: DELETE_USER_UNLOCODE_SELECTION_REQUEST,
    payload: selectionName,
  };
}

export function deleteUserUnlocodeSelectionFailureActionCreator(error) {
  return {
    type: DELETE_USER_UNLOCODE_SELECTION_FAILURE,
    payload: error,
    error: true,
  };
}

export function deleteUserUnlocodeSelectionSuccessActionCreator() {
  return {
    type: DELETE_USER_UNLOCODE_SELECTION_SUCCESS,
  };
}

export function deleteUserProductSelectionRequestActionCreator(selectionName) {
  return {
    type: DELETE_USER_PRODUCT_SELECTION_REQUEST,
    payload: selectionName,
  };
}

export function deleteUserProductSelectionFailureActionCreator(error) {
  return {
    type: DELETE_USER_PRODUCT_SELECTION_FAILURE,
    payload: error,
    error: true,
  };
}

export function deleteUserProductSelectionSuccessActionCreator() {
  return {
    type: DELETE_USER_PRODUCT_SELECTION_SUCCESS,
  };
}

export function fetchUserReportDefinitionsRequestActionCreator() {
  return {
    type: FETCH_USER_DATA_REQUEST,
  };
}

export function fetchUserDataSuccessActionCreator(userReports) {
  return {
    type: FETCH_USER_DATA_SUCCESS,
    payload: {
      userReports,
    },
  };
}

export function fetchUserDataFailureActionCreator(error) {
  return {
    type: FETCH_USER_DATA_FAILURE,
    payload: error,
    error: true,
  };
}

export function reportLastScSetsRequestActionCreator(scSets, directionSet) {
  return {
    type: GET_LAST_SC_SETS_REQUEST,
    payload: {
      scSets,
      directionSet,
    },
  };
}

export function reportLastScSetsSuccessActionCreator(scSets) {
  return {
    type: GET_LAST_SC_SETS_SUCCESS,
    payload: {
      scSets,
    },
  };
}

export function reportLastScSetsFailureActionCreator(scSets) {
  return {
    type: GET_LAST_SC_SETS_FAILURE,
    scSets,
  };
}

export function saveDefaultLaunchPageRequestActionCreator(launchPage) {
  return {
    type: SAVE_DEFAULT_LAUNCH_PAGE_REQUEST,
    payload: {
      launchPage,
    },
  };
}

export function saveDefaultLaunchPageSuccessActionCreator(launchPage) {
  return {
    type: SAVE_DEFAULT_LAUNCH_PAGE_SUCCESS,
    payload: launchPage,
  };
}

export function saveDefaultLaunchPageFailureActionCreator(error) {
  return {
    type: SAVE_DEFAULT_LAUNCH_PAGE_FAILURE,
    payload: error,
    error: true,
  };
}

export function createReqParams(payload) {
  return {
    type: CREATE_REQ_PARAM,
    payload,
  };
}

export function failedReportsDefinitions(payload) {
  return {
    type: FAILED_REPORTS_DEFINITIONS_REQUEST,
    payload,
  };
}

export function sentLastSelections(payload) {
  return {
    type: SENT_LAST_SELECTIONS,
    payload,
  };
}

export function userLoaded(payload) {
  return {
    type: USERLOADED,
    payload,
  };
}

export function lastSelectionsLoaded(payload) {
  return {
    type: LASTSELECTIONSLOADED,
    payload,
  };
}
